import React from 'react';

function Join() {
  return (
       <div id="join_us" className="main bg">
      <h1> This is the join section</h1>
    </div>
  );
}

export default Join;
